import styled from 'styled-components';
import { COLORS, FONT_FAMILY } from '@Commons';

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  gap: 36px;
  max-width: 450px;
`;

export const AvatarWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  align-items: center;

  .MuiAvatar-root {
    width: 80px !important;
    height: 80px !important;
  }

  .MuiBadge-anchorOriginBottomRightCircular {
    img {
      width: 24px !important;
      height: 24px !important;
    }
  }
`;

export const RecipientName = styled.h2`
  font-size: 24px;
  font-weight: 36px;
  font-family: ${FONT_FAMILY.hellix.bold};
  color: ${COLORS.black};
`;

export const ReceivingMethodWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 32px;

  .receiving-method-section {
    display: flex;
    flex-direction: column;
    gap: 16px;
  }

  .receiving-method-title {
    font-size: 18px;
    line-height: 26px;
    font-family: ${FONT_FAMILY.hellix.bold};
    color: ${COLORS.black};
    text-align: left;
  }
`;
export const Wrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 4px;
  min-width: 0;
  font-size: 14px;
  line-height: 22px;
  font-family: ${FONT_FAMILY.hellix.regular};
`;

export const PaymentLabel = styled.span`
  max-width: 160px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  flex-shrink: 1;
`;

export const AccountNumber = styled.span`
  white-space: nowrap;
  flex-shrink: 0;
`;
